import React from 'react'
import { MessageDescriptor, useIntl } from 'react-intl'
import { makeStyles, Theme } from '@material-ui/core/styles'
import LiquidSelect from '@src/components/LiquidSelect'
import { SortState } from './DiscoPromoProductTable'
import { MenuItem } from '@material-ui/core'
import messages from '@src/aem-content/messages'

export interface SortOption {
  column: 'product' | 'productName' | 'productDescription'
  order: 'asc' | 'desc'
  label: MessageDescriptor
}

export enum Sort {
  product = 'product',
  productName = 'productName',
  productDescription = 'productDescription',
}

export const SORT_OPTIONS: SortOption[] = [
  {
    column: Sort.product,
    order: 'asc',
    label: messages.SORT_BY_PRODUCT_NUMBER_ASCENDING,
  },
  {
    column: Sort.product,
    order: 'desc',
    label: messages.SORT_BY_PRODUCT_NUMBER_DESCENDING,
  },
  {
    column: Sort.productName,
    order: 'asc',
    label: messages.SORT_BY_PRODUCT_NAME_ASCENDING,
  },
  {
    column: Sort.productName,
    order: 'desc',
    label: messages.SORT_BY_PRODUCT_NAME_DESCENDING,
  },
  {
    column: Sort.productDescription,
    order: 'asc',
    label: messages.SORT_BY_DESCRIPTION_ASCENDING,
  },
  {
    column: Sort.productDescription,
    order: 'desc',
    label: messages.SORT_BY_DESCRIPTION_DESCENDING,
  },
]

interface DiscoPromoMaterialSortProps {
  loading?: boolean
  value: SortState
  handleUpdateSort: (sort: SortOption) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1 / 2),
    alignSelf: 'stretch',
    padding: theme.spacing(4, 0),
    [theme.breakpoints.up('sm')]: {
      width: '509px',
    },
    '& .MuiSelect-root': {
      minHeight: '40px',
      padding: theme.spacing(2, 2, 2, 4),
      lineHeight: '24px',
      alignItems: 'center',
      alignSelf: 'stretch',
    },
  },
  truncatedLabel: {
    [theme.breakpoints.down(375)]: {
      display: 'block',
      width: '90%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
}))

const DiscoPromoProductsSort: React.FC<DiscoPromoMaterialSortProps> = ({
  loading,
  handleUpdateSort,
  value,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const getSortKey = (opt: SortState) => `${opt.column}-${opt.order}`

  return (
    <div className={classes.sortContainer}>
      <LiquidSelect
        value={getSortKey(value)}
        onChange={(e) => {
          const selectedKey = e.target.value as string
          const selected = SORT_OPTIONS.find(
            (opt) => getSortKey(opt) === selectedKey
          )
          if (selected) handleUpdateSort(selected)
        }}
        size="medium"
        menuMaxHeight={284}
        disabled={loading}
      >
        {SORT_OPTIONS.map((opt) => (
          <MenuItem key={getSortKey(opt)} value={getSortKey(opt)}>
            <span className={classes.truncatedLabel}>
              {formatMessage(opt.label)}
            </span>
          </MenuItem>
        ))}
      </LiquidSelect>
    </div>
  )
}

export default DiscoPromoProductsSort
